import { postCopyBalance } from '../api/postCopyBalance';
import {setGetUserById} from './setGetUserById';

const setPostCopyBalance = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCopyBalance(params);
            dispatch(setGetUserById(params.id));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCopyBalance
}